// javascript
// Автоскролл чата к низу при появлении новых сообщений/стриминге.
// Логика: если пользователь уже находится внизу (или почти внизу) —
// держим его внизу. Если он вручную проскроллил вверх — не мешаем.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    bottomThreshold: { type: Number, default: 80 },
    // Можно отключить автоскролл, например, из data-chat-scroll-enabled-value="false"
    enabled: { type: Boolean, default: true },
  }

  connect() {
    if (!this.enabledValue) return

    this._onScroll = this.onScroll.bind(this)
    this._onMutation = this.onMutation.bind(this)

    this.element.addEventListener("scroll", this._onScroll, { passive: true })
    this._observer = new MutationObserver(this._onMutation)
    this._observer.observe(this.element, {
      childList: true,
      subtree: true,
      characterData: true,
    })

    // При первом открытии — прокрутка вниз.
    this.scrollToBottom({ behavior: "auto" })

    // Проставляем номера (если сервер их не передал).
    this.renumberMessages()
  }

  disconnect() {
    this.element.removeEventListener("scroll", this._onScroll)
    if (this._observer) this._observer.disconnect()
  }

  onScroll() {
    this._stickToBottom = this.isNearBottom()
  }

  onMutation(mutations) {
    if (!this.enabledValue) return

    // Если ранее не было явного scroll — считаем, что надо прилипать к низу.
    if (typeof this._stickToBottom === "undefined") {
      this._stickToBottom = true
    }

    // Не дергаем на каждый символ: агрегируем в 1 кадр.
    if (!this._stickToBottom) return
    if (this._raf) cancelAnimationFrame(this._raf)

    this._raf = requestAnimationFrame(() => {
      this.renumberMessages()
      this.scrollToBottom({ behavior: "auto" })
    })
  }

  renumberMessages() {
    // Нумеруем все сообщения сверху-вниз по DOM-порядку.
    // Серверный номер (если пришёл) — сохраняем.
    const messageNodes = this.element.querySelectorAll('[id^="ai_chat_message_"]')
    let i = 1
    messageNodes.forEach((node) => {
      const wrap = node.querySelector('[data-dae20-chat-seq-wrap]')
      const seq = node.querySelector('[data-dae20-chat-seq]')
      if (!wrap || !seq) {
        i += 1
        return
      }

      // Если сервер уже отрисовал номер — не трогаем.
      const text = (seq.textContent || '').trim()
      if (text !== "") {
        wrap.classList.remove('hidden')
        i += 1
        return
      }

      seq.textContent = `#${i}`
      wrap.classList.remove('hidden')
      i += 1
    })
  }

  isNearBottom() {
    const el = this.element
    const distance = el.scrollHeight - el.scrollTop - el.clientHeight
    return distance <= this.bottomThresholdValue
  }

  scrollToBottom({ behavior = "auto" } = {}) {
    const el = this.element
    // scrollTo с behavior=auto (без анимации) — чтобы не мешать при стриминге.
    el.scrollTo({ top: el.scrollHeight, behavior })
  }
}
